import * as CONSTANTS from '../modules/constants';

export function displayScrollToTop() {
    let scrollToTopContainer = document.querySelector('.adage-scroll-to-top');
    const hiddenClass = 'adage-scroll-to-top-hidden';

    function displayScrollToTop(heightConstraint) {
        if (window.pageYOffset > heightConstraint && scrollToTopContainer.classList.contains(hiddenClass)) {
            scrollToTopContainer.classList.remove(hiddenClass);
        } else if (window.pageYOffset < heightConstraint && !scrollToTopContainer.classList.contains(hiddenClass)) {
            scrollToTopContainer.classList.add(hiddenClass);
        }
    }

    if (scrollToTopContainer != null) {
        window.addEventListener('scroll', function() {
            displayScrollToTop(1250);
        });
    }
}

export function scrollToTop() {
    let scrollToTopBtn = document.getElementById('scrollToTop');

    if (scrollToTopBtn != null) {
        scrollToTopBtn.addEventListener('click', function() {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}
